import { useSearchParams } from 'next/navigation'

export default function useGetParams() {
  const searchParams = useSearchParams()

  const studyid = searchParams.get('studyid')
  const groupname = searchParams.get('groupname')
  const version = searchParams.get('version')
  const utm_source = searchParams.get('utm_source')
  const utm_medium = searchParams.get('utm_medium')
  const utm_campaign = searchParams.get('utm_campaign')
  const time = searchParams.get('time')
  const phone_number = searchParams.get('phone_number')
  const status = searchParams.get('status')
  const traceid = searchParams.get('traceid')
  const study_status = searchParams.get('study_status')
  const portrait_id = searchParams.get('portrait_id')
  const username = searchParams.get('username')
  const token = searchParams.get('token')
  const token_verifier = searchParams.get('token_verifier')
  const source = searchParams.get('source')
  const key = searchParams.get('key')
  const email = searchParams.get('email')
  const category = searchParams.get('category')
  const auto_send_email = searchParams.get('auto_send_email')
  const toast_message = searchParams.get('toast_message')
  const toast_success = searchParams.get('toast_success')
  const toast_description = searchParams.get('toast_description')
  const toast_trace_id = searchParams.get('toast_trace_id')
  const partner_id = searchParams.get('partner_id')
  const signed = searchParams.get('signed')
  const submissionId = searchParams.get('submissionId')
  const is_welcome_survey = searchParams.get('is_welcome_survey')
  const survey_category = searchParams.get('survey_category')
  const notification_title = searchParams.get('notification_title')
  const sub_survey_id = searchParams.get('sub_survey_id')

  return {
    studyid,
    groupname,
    version,
    utm_source,
    utm_medium,
    utm_campaign,
    time,
    phone_number,
    status,
    traceid,
    study_status,
    portrait_id,
    username,
    token,
    token_verifier,
    source,
    key,
    email,
    category,
    auto_send_email,
    toast_message,
    toast_success,
    toast_description,
    toast_trace_id,
    partner_id,
    signed,
    submissionId,
    is_welcome_survey,
    survey_category,
    notification_title,
    sub_survey_id,
  }
}
